// extracted by mini-css-extract-plugin
module.exports = {"area":"Background_area__2KPhw","cubes":"Background_cubes__EDh1l","animate":"Background_animate__3nOO4"};